import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FormDropdown from 'Components/Inputs/FormDropdown';
import { Card } from 'Feature/CommonComponents/ContentComponents';
import { CardType } from 'Feature/CommonComponents/Enums';
import { CardHeader } from 'Components/Card/CardHeader';
import { CardBody } from 'Components/Card/CardBody';
import { FormProvider, useForm } from 'react-hook-form';
import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import styles from './styles.module.scss';
import { ProvincialApplicableRatesProps } from './types';
import ProvincialApplicableRatesTableDetails from './ProvincialApplicableRatesTableDetails';
import { isUserInRoles } from 'Components/Common/UserHelpers/CheckUserRole';
import { ModuleMapping, UserRole } from '@hobt/constants';
import { HbtSitecoreContextType } from 'Foundation/HydrateSitecoreContext';
import { useFeature } from 'flagged';
import { FeatureFlags } from 'Feature/Enums/FeatureFlag.enum';

const ProvincialApplicableRatesTable: React.FC<ProvincialApplicableRatesProps> = (
  props: ProvincialApplicableRatesProps
) => {
  const [province, setProvince] = useState(0);
  const sitecoreContextFactory = useSitecoreContext();
  const sitecoreContext = sitecoreContextFactory?.sitecoreContext as HbtSitecoreContextType;
  const siteTypeIsInternal = useFeature(FeatureFlags.INTERNAL);
  const isMasterUser =
    isUserInRoles(
      ModuleMapping.claim,
      [UserRole.MasterUser],
      sitecoreContext?.user?.moduleRoleMapping
    ) && siteTypeIsInternal === true;

  const isBusinessUser =
    isUserInRoles(
      ModuleMapping.claim,
      [UserRole.BusinessUser],
      sitecoreContext?.user?.moduleRoleMapping
    ) && siteTypeIsInternal === true;
  const access = isMasterUser || isBusinessUser;
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: false,
    defaultValues: {}
  } as Record<string, any>);

  const handelprovince = () => {
    setProvince(methods.getValues('provinceCode'));
  };

  return (
    <Card type={CardType.HORIZONTAL_BLUE}>
      <fieldset disabled={!access}>
        <CardHeader separator>
          <div className="row">
            <div className="col-6">
              <h2 className="card-title">
                <Text field={{ value: props?.fields?.provinceApplicableTableLink?.value }} />
              </h2>
            </div>
            <div className="col-3"></div>
            <div className="col-3">
              <h2 className="card-title">
                <Link to="/provincial-rates">
                  {props?.fields?.provinceApplicableRatesLink?.value}
                </Link>
              </h2>
            </div>
          </div>
        </CardHeader>
        <FormProvider {...methods}>
          <form id="addUserForm" className="form add-user-form" noValidate>
            <CardBody>
              <div className="row card__body-row">
                <div className="form__element form__element--2-column col-1 mt-3">
                  <b>
                    {' '}
                    <Text field={props.fields.provinceLabel} />
                  </b>
                </div>
                <div className="col-11">
                  <FormDropdown
                    name="provinceCode"
                    className={styles.adjustedWidth}
                    label={''}
                    options={props?.fields?.province?.fields?.listItems}
                    setAsNumber={false}
                    isDisabled={false}
                    handleChange={handelprovince}
                  />
                </div>
              </div>
            </CardBody>
          </form>
        </FormProvider>

        {
          <ProvincialApplicableRatesTableDetails
            fields={props.fields.applicableratesTableHeaders.fields}
            provinceId={province}
          />
        }
      </fieldset>
    </Card>
  );
};

export default ProvincialApplicableRatesTable;
